/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Quick_Team_Longest_AgoInputs */



/**
* | output |
* | --- |
* | "Who have I not spoken to for the longest?" |
*
* @param {Chat_Quick_Team_Longest_AgoInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_quick_team_longest_ago = /** @type {((inputs?: Chat_Quick_Team_Longest_AgoInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Quick_Team_Longest_AgoInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wie sprak ik het langst niet?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("À qui n'ai-je pas parlé depuis le plus longtemps ?")
	return /** @type {LocalizedString} */ ("Who have I not spoken to for the longest?")
});